import { useState, useRef } from "react";

import { useHistory } from "react-router-dom";

import Logo from "../../assets/images/Logo-echoed.svg";
import { useAuth } from "../../contexts/authContext";
import { useApi } from "../../hooks/useApi";

import { ChoosePlan } from "./components/choosePlan";
import { EmailVerification } from "./components/emailVerification";
import { Login } from "./components/login";
import { Otp } from "./components/otp";
import { Payment } from "./components/payment";
import { ResetPassword } from "./components/resetPassword";
import { SignUp } from "./components/signUp";

const Auth = () => {
  const { isLoggedIn, loggedIn } = useAuth();
  const { login, signUp } = useApi();
  const history = useHistory();

  // step's: SignUp, otp, email-verification, login, forget, choose-plan, payment, auth-choose-plan

  const [step, setStep] = useState("login");

  const [signInData, setSignInData] = useState({
    email: "john@doe.com",
    password: "1234567",
    waiting: false,
  });
  const [signUpData, setSignUpData] = useState({
    firstName: "John",
    lastName: "Doe",
    email: "john@doe.com",
    organization: "EC",
    phone: "+447030000000",
    password: "1234567",
  });

  const handleSignIn = () => {
    setSignInData((p) => ({ ...p, waiting: true }));

    login({ passwd: signInData.password, email: signInData.email })
      .then((res) => {
        loggedIn({
          ...res,
          accessToken: res.access_token,
          userId: res.uid,
        });
      })
      .finally(() => {
        setSignInData((p) => ({ ...p, waiting: false }));
      });
  };

  const handleSignUp = () => {
    signUp({
      first_name: signUpData.firstName,
      last_name: signUpData.lastName,
      passwd: signUpData.password,
      cell: signUpData.phone,
      email: signUpData.email,
      org_name: signUpData.organization,
    }).then((res) => {
      setStep("otp");
    });
  };

  // START OTP
  const [otp] = useState([]);
  const [otpValueFinal, setOtpValueFinal] = useState("");

  const otpValue = [];

  const list = [...Array(4).keys()];
  const inputRef = useRef([]);

  const otpHandler = (idx) => (e) => {
    const next = inputRef.current[idx + 1];
    otpValue[idx] = e.target.value.slice(0, 1).replace(";", "");
    // console.log(/^\d{0,1}$/.test(e.target.value));
    if (next) next.focus();

    console.log(
      "[otp]",
      otpValue
        .filter((elm) => elm)
        .toString()
        .replaceAll(",", ""),
    );

    otpValue.length === 4 ? setOtpValueFinal(otpValue) : setOtpValueFinal("");
  };

  const inputfocus = (e, x) => {
    if (e.key === "Delete" || e.key === "Backspace") {
      const next = inputRef.current[x - 1];
      otpValue[x] = e.target.value;
      if (next) next.focus();
    }
  };
  // END OTP

  function containsNumbers(str) {
    return /[0-9]/.test(str);
  }

  function containsSymbols(str) {
    return /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(str);
  }

  const isValidEmail = (str) => /\S+@\S+\.\S+/.test(str);

  let passwordStrengthMeter = { strength: "", color: "", width: 0 };
  const passLn = signUpData.password.length;

  if (passLn === 1 || passLn === 2) passwordStrengthMeter = { strength: "Short", color: "#d44949", width: "12.5%" };
  else if (passLn === 3 || passLn === 4) passwordStrengthMeter = { strength: "Weak", color: "#d44949", width: "25%" };
  else if (passLn === 5 || passLn === 6) {
    passwordStrengthMeter = {
      strength: "Good but needs improvement",
      color: "#F0A229",
      width: "50%",
    };
  } else if (passLn > 6) passwordStrengthMeter = { strength: "Strong but not enough", color: "gold", width: "90%" };

  if (passLn > 7 && containsNumbers(signUpData.password) && containsSymbols(signUpData.password)) {
    passwordStrengthMeter = { strength: "Excellent", color: "#27AE60", width: "100%" };
  }

  return (
    <div className={`auth-container ${step === "choose-plan" || step === "payment" ? "auth-choose-plan" : null} `}>
      <div className="container">
        <div className="auth-box">
          <div className="flex-col align-items-center justify-content-center">
            <img src={Logo} alt="logo" className="auth-logo" width="91.9" height="20" />
          </div>
          {step === "SignUp" && (
            <SignUp
              handleSignUp={handleSignUp}
              signUpData={signUpData}
              isValidEmail={isValidEmail}
              passwordStrengthMeter={passwordStrengthMeter}
              setSignUpData={setSignUpData}
              setStep={setStep}
            />
          )}

          {step === "otp" && (
            <Otp
              otp={otp}
              setStep={setStep}
              otpHandler={otpHandler}
              list={list}
              otpValueFinal={otpValueFinal}
              inputRef={inputRef}
              inputFocus={inputfocus}
            />
          )}

          {step === "login" && (
            <Login setStep={setStep} isValidEmail={isValidEmail} handleSignIn={handleSignIn} setSignInData={setSignInData} signInData={signInData} />
          )}

          {step === "forget" && <ResetPassword setStep={setStep} setSignInData={setSignInData} isValidEmail={isValidEmail} signInData={signInData} />}

          {step === "email-verification" && <EmailVerification setStep={setStep} />}

          {step === "choose-plan" && <ChoosePlan setStep={setStep} />}

          {step === "payment" && <Payment setStep={setStep} />}
        </div>
      </div>
    </div>
  );
};

export default Auth;
